// Copyright (C) 2016 Comcast Corporation, All Rights Reserved

"use strict";

window.XtvDataTestScreen = ( function()
{
    XtvDataTestScreen.prototype = new Screen();

    function XtvDataTestScreen(){}

    XtvDataTestScreen.prototype.clearScreen = function ()
    {
        this._message.setVal(Widget.ALPHA, 0);

        for( var i=0; i<this._strings.length; i++ )
            this._strings[i].setText("");

        this._page = 0;
        this._allStrings = [];
    };

    XtvDataTestScreen.prototype.gotFocus = function()
    {
        this.setHighlight();
    };

    XtvDataTestScreen.prototype.init = function()
    {
        var i;
        var self = this;
        var menuStyle = new Style( { color:"#e5e5e5", font:"light", fontSize:_x2.scaleValInt(33), whiteSpace:"nowrap" } );
        var outputStyle = new Style( { color:"#e5e5e5", font:"light", fontSize:_x2.scaleValInt(33), whiteSpace:"nowrap" } );

        this._className = "XtvDataTestScreen";

        Screen.prototype.init.call( this );

        this._tests = [];
        this._tests.push( new StringWidget().init( { text:"Parental Controls",    style:menuStyle, onEnter:function(){ self.getParentalControls()     } } ) );
        this._tests.push( new StringWidget().init( { text:"Set PC Rating",        style:menuStyle, onEnter:function(){ self.setPcRating()             } } ) );
        this._tests.push( new StringWidget().init( { text:"Set PC Setting",       style:menuStyle, onEnter:function(){ self.setPcSetting()            } } ) );

        this._tests.push( new StringWidget().init( { text:"Resume Points",        style:menuStyle, onEnter:function(){ self.getResumePoints(30)       } } ) );
        this._tests.push( new StringWidget().init( { text:"VOD Root",             style:menuStyle, onEnter:function(){ self.getVod()                  } } ) );
        this._tests.push( new StringWidget().init( { text:"VOD Watched",          style:menuStyle, onEnter:function(){ self.getVodWatched()           } } ) );
        this._tests.push( new StringWidget().init( { text:"Recently Watched",     style:menuStyle, onEnter:function(){ self.getRecentlyWatched()      } } ) );
        this._tests.push( new StringWidget().init( { text:"Purchases",            style:menuStyle, onEnter:function(){ self.getPurchases()            } } ) );

        this._tests.push( new StringWidget().init( { text:"Recent Recordings",    style:menuStyle, onEnter:function(){ self.getRecentRecordings()     } } ) );
        this._tests.push( new StringWidget().init( { text:"Scheduled Recordings", style:menuStyle, onEnter:function(){ self.getScheduledRecordings()  } } ) );
        this._tests.push( new StringWidget().init( { text:"All Recordings ",      style:menuStyle, onEnter:function(){ self.getRecordingsByGroup()    } } ) );

        this._tests.push( new StringWidget().init( { text:"Get Channels",         style:menuStyle, onEnter:function(){ self.getChannels()             } } ) );
        this._tests.push( new StringWidget().init( { text:"Get Schedule Block",   style:menuStyle, onEnter:function(){ self.getScheduleBlock()        } } ) );

        this._tests.push( new StringWidget().init( { text:"Search",               style:menuStyle, onEnter:function(){ self.getSearchResult('ab')     } } ) );

        this._tests.push( new StringWidget().init( { text:"Get Entity",           style:menuStyle, onEnter:function(){ self.getEntity()               } } ) );
        this._tests.push( new StringWidget().init( { text:"MOLT",                 style:menuStyle, onEnter:function(){ self.getMolt()                 } } ) );

        this._tests.push( new StringWidget().init( { text:"Settings",             style:menuStyle, onEnter:function(){ self.testSettings()            } } ) );
        this._tests.push( new StringWidget().init( { text:"XACT to XSCT",         style:menuStyle, onEnter:function(){ self.xactToXsct()              } } ) );

        for( i = 0; i < this._tests.length; i++ )
            this.addWidget( this._tests[i], Style._safeLeft );

        //If I wanted to know how many lines I could fit on the screen? I need to add here, but can only measure in resourcesLoaded?

        this._allStrings = [];
        this._strings = [];
        for( i=0; i<20; i++ )
        {
            this._strings[i] = new StringWidget().init( {style:outputStyle, text:"Init"} );
            this.addWidget( this._strings[i], _x2._config._screenW * 0.30 );
        }

        this._index = 0;
        this._page = 0;

        this._message = new StringWidget().init({style:outputStyle, text:"Next [page dn] Prev [page up]"});
        this._message.setVal( Widget.ALPHA, 0);
        this.addWidget( this._message, _x2._config._screenW * 0.30, Style._pad * 5 );

        return this;
    };

    XtvDataTestScreen.prototype.processEvent = function( val, type )
    {
        var retval = true;

        switch( val )
        {
            case Host.KEY_DOWN:
                if( type === Host.KEY_PRESSED && (this._index < this._tests.length - 1) )
                {
                    this._index++;
                    this.setHighlight();
                    this.clearScreen();
                }
                break;

            case Host.KEY_ENTER:
                if( type === Host.KEY_PRESSED )
                {
                    this._tests[this._index].onEnter();
                }
                break;

            case Host.KEY_UP:
                if( type === Host.KEY_PRESSED && (this._index > 0 ) )
                {
                    this._index--;
                    this.setHighlight();
                    this.clearScreen();
                }
                break;

            case Host.KEY_PAGE_DN:
                if( type === Host.KEY_PRESSED )
                {
                    this._page ++ ;
                    this.setStrings();
                }
                break;

            case Host.KEY_PAGE_UP:
                if( type === Host.KEY_PRESSED )
                {
                    if( this._page > 0 )
                    {
                        this._page -- ;
                        this.setStrings();
                    }
                }
                break;

            default:
                retval = Screen.prototype.processEvent.call( this, val, type );
                break;
        }

        return retval;
    };

    XtvDataTestScreen.prototype.resourcesLoaded = function()
    {
        Screen.prototype.resourcesLoaded.call( this );

        var y = this.getHeaderBottom(), i;

        for( i = 0; i < this._tests.length; i++ )
        {
            this._tests[i].setVal( Widget.Y, y );
            y += this._tests[i].getVal( Widget.H ) + Style._pad;
        }

        y = this.getHeaderBottom();

        for( i = 0; i < this._strings.length; i++ )
        {
            this._strings[i].setVal( Widget.Y, y );
            y += this._strings[i].getVal( Widget.H ) + Style._pad;

            this._strings[i].setText("");
        }
    };

    XtvDataTestScreen.prototype.setHighlight = function()
    {
        var obj = this.getGlobalPos();

        obj.x       += this._tests[this._index].getVal( Widget.X );
        obj.y       += this._tests[this._index].getVal( Widget.Y );
        obj.w        = this._tests[this._index].getVal( Widget.W );
        obj.h        = this._tests[this._index].getVal( Widget.H );
        obj.inner    = false;
        obj.duration = 300;

        _x2._hi.setPosition( obj );
    };

    XtvDataTestScreen.prototype.setStrings = function ()
    {
        var start =  this._page      * this._strings.length;
        var end   = (this._page + 1) * this._strings.length - 1;
        var i;

        //clear all
        for( i=0; i<this._strings.length; i++ )
            this._strings[i].setText("");

        //set string widgets to display _allStrings[start] to _allStrings[end]
        for( i=0;i<this._strings.length; i++ )
        {
            this._strings[i].setText( this._allStrings[start] );
            start ++;
            if( start > end )
                break;
        }

        this._message.setVal(Widget.ALPHA, 1);
    };


    /** Test Methods **/

    XtvDataTestScreen.prototype.getChannels = function ()
    {
        var self = this;

        this._strings[0].setText("Getting channels...");

        var success = function()
        {
            var collection = _x2._channelCollection;
            self._channelCollection = collection;
            var channels = collection.getChannels();
            self.printChannels( channels );
        };

        var error = function(error )
        {
            console.log(error);
        };

        this._scheduleStart = Date.now();
        _x2._channelCollection.fetch( this._scheduleStart ).then( success ).catch( error );
    };

    XtvDataTestScreen.prototype.getEntity = function ()
    {
        var self = this;

        this._strings[0].setText("Getting entity...");

        _x2._data.getProgramEntity({programId:"5992010106256768112"}).then(
            function (entity)
            {
                self._allStrings.push(entity.getProgram().getTitle());
                self._allStrings.push(entity.getProgram().getDescription());
                self.setStrings(0);
            }
        ).catch(
            function (error)
            {
                self._strings[0].setText( error );
            }
        )
    };

    XtvDataTestScreen.prototype.getMolt = function()
    {
        var self = this;

        this._strings[0].setText("Getting MOLT...");

        _x2._data.getMoreLikeThis("5992010106256768112").then(
            function (entities)
            {
                if( entities.length )
                {
                    for( var i=0; i<entities.length; i++ )
                        self._allStrings.push( entities[i].getName() );
                }
                else
                    self._allStrings.push( "No MOLT found" );

                self.setStrings(0);
            }
        ).catch(
            function (error)
            {
                self._strings[0].setText( "Error:" +  error );
            }
        )
    };

    XtvDataTestScreen.prototype.getParentalControls = function ()
    {
        var self = this;

        this._strings[0].setText("Getting parental controls...");

        _x2._data.getParentalControls().then(
            function (pc)
            {
                pc = pc._data;
                for (var property in pc)
                {
                    if (pc.hasOwnProperty(property))
                        self._allStrings.push( property + ":" + pc[property] );
                }
                self.setStrings(0);
            }
        ).catch(
            function (error)
            {
                self._strings[0].setText( error );
            }
        )
    };


    XtvDataTestScreen.prototype.getPurchases = function()
    {
        var self = this;

        this._strings[0].setText("Getting Purchases...");

        _x2._data.getPurchases().then(
            function (entities)
            {
                if( entities.length )
                {
                    for( var i=0; i<entities.length; i++ )
                        self._allStrings.push( entities[i].getTitle() );
                }
                else
                    self._allStrings.push( "No purchases found" );

                self.setStrings(0);
            }
        ).catch(
            function (error)
            {
                self._strings[0].setText( "Error:" +  error );
            }
        )
    };

    XtvDataTestScreen.prototype.getRecentlyWatched = function()
    {
        var self = this;

        this._strings[0].setText("Getting Recently Watched...");

        _x2._data.getRecentlyWatched().then(
            function (entities)
            {
                if( entities.length )
                {
                    for( var i=0; i<entities.length; i++ )
                        self._allStrings.push( entities[i].getTitle() );
                }
                else
                    self._allStrings.push( "No recently watched found" );

                self.setStrings(0);
            }
        ).catch(
            function (error)
            {
                self._strings[0].setText( "Error:" +  error );
            }
        )
    };

    XtvDataTestScreen.prototype.getRecentRecordings = function ()
    {
        var self = this;

        this._strings[0].setText("Getting recent recordings...");

        _x2._data.getRecentRecordings().then(
            function (recordings)
            {
                for( var i=0; i<recordings.length; i++ )
                {
                    var props = [];
                    props.push(recordings[i].getChannel().getNumber() );
                    props.push(recordings[i].getTitle());
                    props.push(recordings[i].getRecordedOnDate());
                    self._allStrings.push( props.join(' - ') );
                }
                self.setStrings(0);
            }
        ).catch(
            function (error)
            {
                self._strings[0].setText( error );
            }
        )
    };

    XtvDataTestScreen.prototype.getRecordingsByGroup = function ()
    {
        var self = this;

        this._strings[0].setText("Getting grouped recordings...");

        _x2._data.getRecordingsByGroup().then(
            function (groups)
            {
                for( var i=0; i<groups.length; i++ )
                {
                    var groupName = groups[i].getName();
                    var recordings = groups[i].getRecordings();

                    if( recordings && recordings.length )
                    {
                        self._allStrings.push( groupName );

                        for( var q=0; q<recordings.length; q++ )
                        {
                            var props = [];
                            props.push(recordings[q].getChannel().getNumber() );
                            props.push(recordings[q].getTitle());
                            props.push(recordings[q].getRecordedOnDate());
                            self._allStrings.push( props.join(' - ') );
                        }
                    }
                }
                self.setStrings(0);
            }
        ).catch(
            function (error)
            {
                self._strings[0].setText( error );
            }
        )
    };

    XtvDataTestScreen.prototype.getResumePoints = function( daysOld )
    {
        var self = this;

        this._strings[0].setText( "Getting resume points..." );

        _x2._data.getResumePoints( daysOld ).then(
            function( resumePoints )
            {
                for( var rp in resumePoints )
                {
                    if( resumePoints.hasOwnProperty( rp ) )
                        self._allStrings.push( resumePoints[rp].getPosition() + " - " + resumePoints[rp].getMediaId() );
                }
                self.setStrings( 0 );
            }
        ).catch(
            function( error )
            {
                self._strings[0].setText( error );
            }
        )
    };

    XtvDataTestScreen.prototype.getListingDetail = function ()
    {
        var self = this;

        this._strings[0].setText("Getting listing detail...");

        _x2._data.getScheduleBlock(Date.now(),1).then(
            function (channels)
            {
                //get a random schedule from the grid
                var listing = channels[55].getListings()[0];

                _x2._data.getListingDetail(listing).then(
                    function (listing)
                    {
                        var listingData = listing._data
                        for (var property in listingData)
                        {
                            if (listingData.hasOwnProperty(property))
                                self._allStrings.push( property + ":" + listingData[property]);
                        }
                        self.setStrings(0);
                    }
                ).catch(
                    function (error)
                    {
                        self._strings[0].setText( error );
                    }
                )
            }
        ).catch(
            function (error)
            {
                self._strings[0].setText( error );

            }
        )
    };

    XtvDataTestScreen.prototype.setRecording = function ()
    {
        var self = this;

        this._strings[0].setText("Setting recording...");

        _x2._data.getScheduleBlock(Date.now(),1).then(
            function (channels)
            {
                //get a random schedule from the grid
                var listing = channels[55].getListings()[0];

                _x2._data.getListingDetail(listing).then(
                    function (listing)
                    {
                        _x2._data.setRecording( listing, false, {} ).then(
                            function (resp)
                            {
                                self._strings[0].setText( "Recording set!");
                            }
                        ).catch(
                            function (error)
                            {
                                self._strings[0].setText( "Error:" + error );
                            }
                        )
                    }
                ).catch(
                    function (error)
                    {
                        self._strings[0].setText( error );
                    }
                )
            }
        ).catch(
            function (error)
            {
                self._strings[0].setText( error );

            }
        )
    };

    XtvDataTestScreen.prototype.getScheduleBlock = function ()
    {
        var self = this;

        this._strings[0].setText("Getting schedule block...");

        //move start forward by 1 hour on each press
        this._scheduleStart += ( 240 * 60 * 1000 );

        var success = function( obj )
        {
            var startTime = obj.startTime;
            var channels = obj.channels;
            self.printChannels( channels );
        };

        var error = function( error )
        {
            console.log( error );
        };

        _x2._channelCollection.fetch( this._scheduleStart, this._scheduleStart + ( 180 * 60 * 1000), 0 ).then( success ).catch( error );
    };

    XtvDataTestScreen.prototype.printChannels = function( channels )
    {
        for( var i=0; i<channels.length; i++ )
        {
            var channel = channels[i];

            var props = [];
            props.push( "------" );
            props.push( channel.getNumber() );
            props.push( channel.getCallSign() );
            props.push( channel.getCompany() );
            props.push( "------" );
            this._allStrings.push( props.join( '-' ) );

            var schedules = channel.getSchedules();
            if( schedules )
            {
                for( var q=0; q<schedules.length; q++ )
                {
                    var lProps = [];
                    lProps.push( schedules[q].getTitle() );
                    lProps.push( "-" ) ;
                    lProps.push( schedules[q].getEntityId() );
                    lProps.push( ( new Date(schedules[q].getStartTime()).toLocaleTimeString() ) );
                    lProps.push( "-" ) ;
                    lProps.push( ( new Date(schedules[q].getEndTime()).toLocaleTimeString()) ) ;
                    this._allStrings.push( lProps.join(' ') );
                }
            }
        }
        this.setStrings(0);
    };

    XtvDataTestScreen.prototype.getScheduledRecordings = function()
    {
        var self = this;

        this._strings[0].setText("Getting Scheduled...");

        _x2._data.getScheduledRecordings().then(
            function (entities)
            {
                if( entities.length )
                {
                    for( var i=0; i<entities.length; i++ )
                        self._allStrings.push( entities[i].getTitle() );
                }
                else
                    self._allStrings.push( "No scheduled programs found" );

                self.setStrings(0);
            }
        ).catch(
            function (error)
            {
                self._strings[0].setText( "Error:" +  error );
            }
        )
    };

    XtvDataTestScreen.prototype.getSearchResult = function (string)
    {
        var self = this;

        this.clearScreen();
        this._strings[0].setText("Search...");

        _x2._data.search(string, 10).then(
            function (entities)
            {
                for( var i=0; i<entities.length; i++ )
                {
                    var props = [];
                    props.push( entities[i].getName() );
                    props.push( entities[i].getSubtitle() );
                    self._allStrings.push( props.join(' ') );
                }
                self.setStrings(0);
            }
        ).catch(
            function (error)
            {
                self._strings[0].setText( error );
            }
        )
    };

    XtvDataTestScreen.prototype.getVod = function ()
    {
        var self = this;

        this.clearScreen();
        this._strings[0].setText("Getting VOD...");

        _x2._data.getVodRoot().then(
            function (data)
            {
                var i, items = data.getEmbeddedBrowseItems();

                self._allStrings.push( items.length + " Items: ");

                for( i=0; i<items.length; i++ )
                    self._allStrings.push( items[i].getTitle() );

                self.setStrings(0);
            }
        ).catch(
            function (error)
            {
                self._strings[0].setText( error );
            }
        )
    };

    XtvDataTestScreen.prototype.getVodWatched = function()
    {
        var self = this;

        this._strings[0].setText("Getting Watched...");

        _x2._data.getVodWatched().then(
            function (entities)
            {
                if( entities.length )
                {
                    for( var i=0; i<entities.length; i++ )
                        self._allStrings.push( entities[i].getTitle() );
                }
                else
                    self._allStrings.push( "No watched found" );

                self.setStrings(0);
            }
        ).catch(
            function (error)
            {
                self._strings[0].setText( "Error:" +  error );
            }
        )
    };

    XtvDataTestScreen.prototype.setPcRating = function()
    {
        var self = this;

        this._strings[0].setText("Setting PC Rating...");

        _x2._data.getParentalControls().then(
            function (pc)
            {
                pc.setMovieRatingLock( ParentalControls.MpaaRatings.NC17, true ) ;

                _x2._data.setParentalControlsRatings( pc )
                   .then( function () { self._strings[0].setText( "Set NC-17 locked to true." ); } )
                   .catch( function (error) { self._strings[0].setText( "Error:" +  error ); } );
            }
        ).catch(function (error) { self._strings[0].setText( "Error:" +  error ); } );
    };

    XtvDataTestScreen.prototype.setPcSetting = function()
    {
        var self = this;

        this._strings[0].setText("Setting PC Setting...");

        _x2._data.getParentalControls().then(
            function (pc)
            {
                pc.setSafeBrowse( ParentalControls.SafeBrowse.HIGH );

                _x2._data.setParentalControlsSettings( pc )
                   .then( function () { self._strings[0].setText( "Set Safe Browse to HIGH" ); } )
                   .catch( function (error) { self._strings[0].setText( "Error:" +  error ); } );
            }
        ).catch(function (error) { self._strings[0].setText( "Error:" +  error ); } );
    };

    XtvDataTestScreen.prototype.testSettings = function()
    {
        //set random darkness level between 1 and 5, then get and display.
        var darkness = Math.floor(Math.random() * 5) + 1;
        _x2._settings.setValue(Settings.BG_DARKNESS, darkness);

        this._strings[0].setText("BG Darkness: " + _x2._settings.getValue(Settings.BG_DARKNESS));
    };

    XtvDataTestScreen.prototype.xactToXsct = function ()
    {
        var self = this;
        this._strings[0].setText("Getting XSCT Token...");

        var xact = "PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4NCjxuczI6eGNhbC1hdXRoLW1lc3NhZ2UgeG1sbnM6bnMyPSJ1cm46Y2NwOmRldmlkOmRybSIgdmVyc2lvbj0iMyI%2BPGF0dHJpYnV0ZSBrZXk9Im1lc3NhZ2U6cHJvdGVjdGlvbiI%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%2BeGFjczwvYXR0cmlidXRlPjxhdHRyaWJ1dGUga2V5PSJkZXZpY2U6bG9jYXRpb25JcCI%2BODcuNjcuNS40NDwvYXR0cmlidXRlPjxhdHRyaWJ1dGUga2V5PSJkZXZpY2U6Zmxhc2hBY2Nlc3M6bG9jYXRpb25JcCI%2BODcuNjcuNS40NDwvYXR0cmlidXRlPjxhdHRyaWJ1dGUga2V5PSJsb2NhdGlvbjpuZXQtaXAiPjg3LjY3LjUuNDQ8L2F0dHJpYnV0ZT48YXR0cmlidXRlIGtleT0ibWVzc2FnZTppZCI%2BdHJhY2UtaWQ9ZGUxY2MyMjYtNzg2Ni00Y2I2LTkyN2MtNjY0N2VjYTM1N2ZjO3BhcmVudC1pZD0zMDg1NTIxNzIwOTg3MDQ3MTMwO3NwYW4taWQ9MzA4NTUyMTcyMDk4NzA0NzEzMDwvYXR0cmlidXRlPjxhdHRyaWJ1dGUga2V5PSJkZXZpY2U6aWQiPjFXSzlLRkRNRkEwNDdDQjZCRDVSPC9hdHRyaWJ1dGU%2BPGF0dHJpYnV0ZSBrZXk9ImRldmljZTpmbGFzaEFjY2VzczppZCI%2BMVdLOUtGRE1GQTA0N0NCNkJENVI8L2F0dHJpYnV0ZT48YXR0cmlidXRlIGtleT0iZHJtOmZsYXNoQWNjZXNzOmRldmljZS1pZCI%2BMVdLOUtGRE1GQTA0N0NCNkJENVI8L2F0dHJpYnV0ZT48YXR0cmlidXRlIGtleT0iZGV2aWNlOmNsYXNzIj5wY01hYzwvYXR0cmlidXRlPjxhdHRyaWJ1dGUga2V5PSJzZXJ2aWNlOnhjYWw6cHJvZHVjdCI%2BY2R2cjwvYXR0cmlidXRlPjxhdHRyaWJ1dGUga2V5PSJ4Y2FsOnByb2R1Y3QiPmNkdnI8L2F0dHJpYnV0ZT48YXR0cmlidXRlIGtleT0iY2xpZW50OnNlc3Npb25LZXkiPlFqQ0NBUjhNQVRJWERURTJNVEF5TlRBNU1qVXdOMW9NQVRRRUVKWWx1WkoxQ1JVeVVvSDU2MW10RnFNTUFUVUVGQkltUmptZWp1a3hOcTNIajVWTjlzK3FpbE5hREFFMkJJR2RNSUdhREFFeERCQXhWMHRXVFUxVFJ6bE5NbE5VVUVSRERBRXlEQmxIWlc1bGNtRjBaV1JFWlhacFkyVkpaRlpsY25OcGIyNHhEQUV6REJReFYwczVTMFpFVFVaQk1EUTNRMEkyUWtRMVVnd0JOQXdGY0dOTllXTU1BVFVNQ21odFlXTlRhR0V5TlRZTUFUWUVNSGE2RkxzSld1SUlRQW9oUDNzclc5OTJvVWFDUlBRZXZnc0VqRDFtUVk4bFVJYitNY1g5UzVlZk1lMzNma0cxV2d3Qk53d1pZMjl0WTJGemRDMXdNREV0ZUdGamN5MHdNamN0WVcxMGJRd0JPQXdaWTI5dFkyRnpkQzF3TURFdGVHRmpjeTB3TWpZdFlXMTBaUT09PC9hdHRyaWJ1dGU%2BPGF0dHJpYnV0ZSBrZXk9ImFjY291bnQ6eGNhbDp0b2tlbklkIj56WFFmRlFyMU1Td1JSbndsN0Y5TWVkTll1WGs9PC9hdHRyaWJ1dGU%2BPGF0dHJpYnV0ZSBrZXk9InNlcnZpY2U6cHJvdmlkZXIiPnhjYWw8L2F0dHJpYnV0ZT48YXR0cmlidXRlIGtleT0ic2VydmljZTpwcm92aWRlcnMiPnhjYWw8L2F0dHJpYnV0ZT48YXR0cmlidXRlIGtleT0iZGV2aWNlOmZsYXNoQWNjZXNzOmRldmljZS10eXBlIj5QQzwvYXR0cmlidXRlPjxhdHRyaWJ1dGUga2V5PSJkZXZpY2U6bW9kZWwiPlBDPC9hdHRyaWJ1dGU%2BPGF0dHJpYnV0ZSBrZXk9ImRldmljZTp0eXBlIj5JcENvYW08L2F0dHJpYnV0ZT48YXR0cmlidXRlIGtleT0iZGV2aWNlOmNhdGVnb3J5Ij5NYWM8L2F0dHJpYnV0ZT48YXR0cmlidXRlIGtleT0iZGV2aWNlOnByb3ZpZGVycyI%2BZmxhc2hBY2Nlc3M8L2F0dHJpYnV0ZT48L25zMjp4Y2FsLWF1dGgtbWVzc2FnZT4NCg%3D%3D";

        _x2._data.createDrmSession(xact).then(
            function (data)
            {
                var drmObj = JSON.parse(data);
                self._strings[0].setText(drmObj.xsct);
            }
        ).catch(
            function (error)
            {
                self._strings[0].setText(error);
            }
        )
    };

    return XtvDataTestScreen;

})();

